import { Component, OnInit, Input, Output,EventEmitter} from '@angular/core';

@Component({
  selector: 'obtener-orden-actividades-check',
  template: `
    <ul>
      <li *ngFor="let item of insumos;let i = index">
      <div class="p-0 border-checkbox-section">
        <div class="border-checkbox-group">
            <input
                class="border-checkbox"
                type="checkbox"
                [disabled]="desactivar"
                id="item_{{i}}"
                [(ngModel)]="item.check"
                (change)="changeCheck()"
                >
            <label class="border-checkbox-label" for="item_{{i}}"> {{item.descripcion}}</label>
        </div>
      </div>
      </li>
    </ul>
  `,
  styles: []
})
export class ObtenerOrdenActividadesCheckComponent implements OnInit {
  @Input() seleccionado
  @Input() desactivar: boolean = false
  @Output() envioSelec= new EventEmitter()
  insumos : any
  constructor() { }
  ngOnInit() {
    this.insumos = [
      {id:1,descripcion:'Orden 1',orden:1, check: false},
      {id:2,descripcion:'Orden 2',orden:2, check: false},
      {id:3,descripcion:'Orden 3',orden:3, check: false},
      {id:4,descripcion:'Orden 4',orden:4, check: false},
      {id:5,descripcion:'Orden 5',orden:5, check: false},
      {id:5,descripcion:'Orden 6',orden:6, check: false},
      {id:5,descripcion:'Orden 7',orden:7, check: false},
      {id:5,descripcion:'Orden 8',orden:8, check: false},
    ]
    this.asignarCheck(this.seleccionado)
  }
 
  asignarCheck(items){

    let insumosActivos = (items) ? items.split(",") : []
    for(let insumo of this.insumos){
      for(let activo of insumosActivos){
        if(insumo.orden == activo)
          insumo.check = true
      }
    }
    this.changeCheck()
  }

  changeCheck(){
    let orden =[]
    for(let item of this.insumos){
      if(item.check)
        orden.push(item.orden)
    }
    this.envioSelec.emit(orden.toString())
  }
  

}



// WEBPACK FOOTER //
// ./src/app/shared/element/obtener-orden-actividades-check.component.ts